import api from './axios';

const params = (idEmpresa) => (idEmpresa ? { id_empresa: idEmpresa } : undefined);

export const listFornecedores = (incluirInativos) =>
  api.get('/fornecedores/', { params: incluirInativos ? { incluir_inativos: true } : undefined });
export const createFornecedor = (data, idEmpresa) => api.post('/fornecedores/', data, { params: params(idEmpresa) });
export const updateFornecedor = (id, data, idEmpresa) =>
  api.patch(`/fornecedores/${id}`, data, { params: params(idEmpresa) });
